import { CountDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { NUMBER } from 'customer-data-objects/property/PropertyTypes';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
export const makeEventCountField = filterFamily => {
  return DSFieldRecord({
    displayType: CountDisplayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.${filterFamily}.${EVENT_BASED_FIELD_KEYS.EVENT_COUNT}`),
    name: EVENT_BASED_FIELD_KEYS.EVENT_COUNT,
    type: NUMBER,
    displayOrder: 3,
    refinement: true
  });
};